module.exports = __webpack_public_path__ + "img/closecard.6635d871.svg";